<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (searchCourse = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="searchCourse"
            :items="courses"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="accent"
                :disabled="!item.active"
                @click="editCourse(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item, 'course')"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
            <template #[`item.department_id`]="{ item }">
              {{ getDepartment(item) }}
            </template>
            <template #[`item.objectives`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.objectives, 'Objective')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.outcomes`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.outcomes, 'Outcome')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.experiments`]="{ item }">
              <div>
                <v-chip
                  v-if="item.experiments && item.experiments.length"
                  small
                  @click="showData(item.name, item.experiments, 'Experiment')"
                >
                  View
                </v-chip>
                <span v-else>-</span>
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createCourse"
        @update="updateCourse"
        :course="course"
        :department_id="parseInt(department_id)"
        :departments="departments"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showConfirmDialog"
      :show="showConfirmDialog"
      @delete="changeConfirmation"
      @close="showConfirmDialog = false"
      title="course"
      :name="currentItem.name"
      :active="currentItem.active"
    />
    <v-dialog v-model="showDialog" max-width="600" persistent scrollable>
      <v-card class="secondary">
        <v-card-title class="primary white--text"
          >{{ selectedItem.name }} - {{ selectedItem.content_name }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="showDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="mt-3 reset-card-text">
          <div v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/course/form.vue";
import searchBar from "@/components/searchBar.vue";
import { courseHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";

export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      currentItem: {},
      courses: [],
      departments: [],
      department_id: null,
      searchCourse: "",
      headers: courseHeaders,
      showConfirmDialog: false,
      showDialog: false,
      selectedItem: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.department_id = this.$route.params.id;
    this.setBreadcrumbs();
    this.initialise();
  },
  methods: {
    setBreadcrumbs(departmentName) {
      const name = departmentName || this.$route.query.name;
      if (name) {
        this.$store.commit("setBreadcrumbs", [
          { text: "Departments", to: { name: "Departments" } },
          { text: name, to: { path: `/departments/${this.department_id}` } },
          { text: "Courses" },
        ]);
      } else {
        this.$axios.get("departments").then((res) => {
          const department = res.data.data.find(
            (d) => d.id == this.department_id
          );
          this.setBreadcrumbs(department?.name);
        });
      }
    },
    initialise() {
      this.getCourses();
      this.getDepartments();
    },
    async getCourses() {
      await this.$axios
        .get("courses")
        .then((res) => {
          const response = res.data.data;
          this.courses = response
            .filter((c) => c.department_id == this.department_id)
            .sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getDepartments() {
      await this.$axios
        .get("departments")
        .then((res) => {
          this.departments = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async createCourse(data) {
      await this.$axios
        .post("courses", { course: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateCourse(data) {
      await this.$axios
        .put("courses/" + data.id, { course: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.course = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.course = {};
      this.currentItem = {};
      this.showConfirmDialog = false;
    },
    getDepartment(item) {
      return this.departments.find((x) => x.id == item.department_id)?.name;
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = this.showActiveStatus(item.active);
      const department = this.getDepartment(item.department_id);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        activeStatus?.toLowerCase().includes(search.toLowerCase()) ||
        department?.toLowerCase().includes(search.toLowerCase())
      );
    },
    openConfirm(item, title) {
      this.currentItem = { ...item };
      this.showConfirmDialog = true;
    },
    changeConfirmation() {
      this.updateCourse({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    showData(name, content, content_name) {
      this.showDialog = true;
      this.selectedItem.description = content;
      this.selectedItem.name = name;
      this.selectedItem.content_name = content_name;
    },
  },
};
</script>

<style></style>
